import { useMemo } from 'react'

import { Divider } from 'src/components/atoms/Divider'
import { ButtonLink, ExternalLink } from 'src/components/atoms/Link'
import { Paragraph } from 'src/components/atoms/Typography'

import { useListOpenSeasonsQuery } from 'src/config/generated/graphql'
import { listProjectsPath, selectProjectPath } from 'src/config/paths'

export const PlanterActionPanel = () => {
  const { data: seasonsData } = useListOpenSeasonsQuery()

  const plantingSeason = useMemo(() => {
    if (!seasonsData || seasonsData.Season.length === 0) return null
    return seasonsData.Season[seasonsData.Season.length - 1]
  }, [seasonsData])

  return (
    <div className='flex flex-col gap-5 md:gap-10'>
      <div className='flex flex-col gap-5'>
        <Paragraph className='text-[16px] leading-[24px] font-medium !m-0'>
          Send in your tree application for {plantingSeason?.Name}.
        </Paragraph>
        <ButtonLink size='large' variant='contained' href={selectProjectPath}>
          Request trees
        </ButtonLink>
        <ButtonLink size='large' href={listProjectsPath} variant='outlined'>
          View your projects
        </ButtonLink>
      </div>
      <Divider className='!m-0' />
      <Paragraph className='text-[16px] leading-[24px] font-medium !m-0'>
        Need a hand?{' '}
        <ExternalLink href='https://help.treesthatcount.co.nz/en/collections/5922918-planting'>
          Visit our Help Centre.
        </ExternalLink>
      </Paragraph>
    </div>
  )
}
